import React from "react";
import dayjs from "dayjs";
import { Clock } from "lucide-react";

const normalizeTime = (value) => String(value || "").slice(0, 5);

const normalizeStatus = (value) =>
  String(value || "livre")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

const normalizeSlot = (slot) => {
  if (typeof slot === "string") {
    return { hora: normalizeTime(slot), status: "livre" };
  }

  return {
    ...(slot && typeof slot === "object" ? slot : {}),
    hora: normalizeTime(slot?.hora),
    status: normalizeStatus(slot?.status),
  };
};

const getSlotMeta = ({ slot, selected, date, allowSelectedPast }) => {
  const item = normalizeSlot(slot);
  const selectedTime = normalizeTime(selected);
  const isSelected = selectedTime === item.hora;
  const isPast =
    date && item.hora
      ? dayjs(`${date}T${item.hora}`).isBefore(dayjs())
      : false;
  const status =
    isPast && !(allowSelectedPast && isSelected) ? "passado" : item.status;
  const disabledStatuses = ["ocupado", "indisponivel", "passado"];
  const labelByStatus = {
    livre: "Livre",
    ocupado: "Ocupado",
    indisponivel: "Indisponível",
    passado: "Passado",
    atual: "Horário atual",
  };

  return {
    ...item,
    status,
    disabled: disabledStatuses.includes(status),
    selected: isSelected,
    label: labelByStatus[status] || "Livre",
  };
};

const FilaZeroTimeSlotPicker = ({
  value,
  onChange,
  name = "hora",
  slots = [],
  date,
  loading = false,
  disabled = false,
  allowSelectedPast = false,
  placeholder = "Selecione os dados acima para ver os horários.",
  emptyText = "Nenhum horário disponível para essa combinação.",
  error,
}) => {
  const normalizedSlots = (Array.isArray(slots) ? slots : [])
    .map((slot) =>
      getSlotMeta({ slot, selected: value, date, allowSelectedPast })
    )
    .filter((slot) => slot.hora);

  const handleSelect = (slot) => {
    if (slot.disabled || disabled) return;
    onChange?.({ target: { name, value: slot.hora } });
  };

  return (
    <div className="fz-time-slot-picker">
      <div className="fz-time-slot-picker__header">
        <Clock size={16} />
        <span>Horários disponíveis</span>
      </div>

      {loading ? (
        <div className="fz-time-slot-picker__state">Carregando horários...</div>
      ) : disabled ? (
        <div className="fz-time-slot-picker__state">{placeholder}</div>
      ) : normalizedSlots.length === 0 ? (
        <div className="fz-time-slot-picker__state">{emptyText}</div>
      ) : (
        <div className="fz-time-slot-grid">
          {normalizedSlots.map((slot, index) => (
            <button
              key={`${slot.hora}-${slot.status}-${index}`}
              type="button"
              disabled={slot.disabled}
              className={[
                "fz-time-slot",
                `fz-time-slot--${slot.status}`,
                slot.selected ? "is-selected" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              onClick={() => handleSelect(slot)}
              title={`${slot.hora} - ${slot.label}`}
            >
              <strong>{slot.hora}</strong>
              <span>{slot.label}</span>
            </button>
          ))}
        </div>
      )}

      {error && <div className="error-text">{error}</div>}
    </div>
  );
};

export default FilaZeroTimeSlotPicker;
